import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="about" className="py-24 px-6 relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px" style={{
      background: 'linear-gradient(to right, transparent, var(--chart-3), transparent)'
    }} />

      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image side */}
          <motion.div initial={{
          opacity: 0,
          x: -32
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative">
            <div className="rounded-2xl overflow-hidden border border-border" style={{
            boxShadow: '0 30px 80px -20px oklch(0.65 0.18 180 / 0.2)'
          }}>
              <img src="https://static-us-img.skywork.ai/prod/user/head_picture/2038040032211152896_DSCF4103.jpg?image_process=quality,q_90/resize,w_1280/format,webp" alt="Konstantin Solopov studio — K.S. Score & Sound" className="w-full h-[291.265625px] object-cover" />
            </div>
            {/* Brand collage thumbnail */}
            
          </motion.div>

          {/* Text side */}
          <motion.div initial={{
          opacity: 0,
          x: 32
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }}>
            <p className="text-xs font-mono text-chart-3 uppercase tracking-widest mb-4">
              About
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 leading-tight">
              Telling Stories
              <br />
              <span className="text-primary">Through Sound</span>
            </h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed text-sm md:text-base">
              <p>
                <strong className="text-foreground">Konstantin Solopov</strong> is a Russian-born
                composer specialising in film and video game scoring, currently completing a dual
                major in Film Scoring and Video Game Scoring at{' '}
                <strong className="text-foreground">Berklee College of Music</strong>. Born in
                Moscow, he began formal music education young — though a serious path in composition
                felt unthinkable at the time. That changed after moving to Cyprus at 13: an IGCSE
                composition assignment reignited his passion and revealed what music could truly be
                — a way to tell stories, evoke emotion, and comment on the world. His classical
                training, once a chore, became a wellspring. Music had become his voice.
              </p>
              <p>
                Back in Cyprus he began working professionally, scoring local projects and composing
                25 cues for a full stage production of{' '}
                <em className="text-foreground">A Midsummer Night's Dream</em>. Now based in the
                U.S., his recent credits include a short film about BU and BC rowers, and a
                semi-finalist placing in the{' '}
                <strong className="text-foreground">Red Bull Scoring Challenge 2024</strong> in
                Vienna. A standout Berklee experience was collaborating with USC — working
                alongside game developers, sound designers, and audio directors across three
                separate projects, each time taking a different creative role.
              </p>
              <p>
                Technically fluent across DAWs (Logic Pro, Cubase, Ableton Live), notation
                software (Dorico, Sibelius), audio middleware (FMOD, Wwise), and game engines
                (Unity, Unreal Engine), Konstantin bridges creativity and craft at every layer of
                the audio pipeline. As graduation approaches in spring 2026, he is setting his
                sights on Los Angeles — ready to compose, orchestrate, supervise, and push the
                boundaries of media music across every platform and genre.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-10">
              {[{
              value: 'BM',
              label: 'Berklee College of Music'
            }, {
              value: '\'26',
              label: 'Graduating Spring'
            }, {
              value: 'L.A.',
              label: 'Next Destination'
            }].map(stat => <div key={stat.label} className="text-center">
                  <p className="text-3xl font-bold mb-1" style={{
                color: 'var(--primary)'
              }}>
                    {stat.value}
                  </p>
                  <p className="text-xs text-muted-foreground uppercase tracking-wide">
                    {stat.label}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}